import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

import { DeleteOutlined } from '@ant-design/icons'
import { styles } from './styles'
import Title from '../../components/Title'
import { withContext } from '../../context'
import { isMobile } from '../../utils'
import {
  Avatar,
  Button,
  message,
  Modal,
  Popconfirm,
  Row,
  Space,
  Tabs
} from 'antd'
import Card from '@material-ui/core/Card'
import { CardContentEx, TableEx, TabsEx } from '../../shared.style'
import { useDeepEffect } from '../../utils/hooks'
import LogoNoMaterial from '../../assets/images/icon_no_material_402x.png'
import { Text } from '../AccountProduct/index.style'
import axios from 'axios'
import LocationBin from './LocationBin'
import { ButtonEx } from '../HeroLocations/index.style'
import { isEmpty, remove } from 'lodash'
import { RESPONSE_MESSAGE } from '../../utils/constants'
import LocationDelete from './LocationDelete'
import PreviewImage from '../../components/PreviewImage'

const { TabPane } = Tabs

export const AccountLocationBin = ({
  history: { goBack, push },
  context: { state },
  me
}) => {
  const [locationList, setLocationList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [loading, setLoading] = useState(false)
  const [locationItem, setLocationItem] = useState(null)
  const [locationId, setLocationId] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)

  async function fetchData() {
    setLoading(true)
    const res = await axios.get(
      process.env.REACT_APP_API_ENDPOINT + `/hero/${me.id}/location`
    )

    setLoading(false)
    setLocationList(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const onClick = (e) => {
    e.preventDefault()
    setLocationItem(null)
    setVisible(true)
  }

  const onCancel = () => {
    setLocationItem(null)
    setVisible(false)
  }

  const onEdit = (location) => {
    setVisible(true)
    setLocationItem(location)
  }

  const onDelete = async () => {
    const arr = []
    setLocationList((prevState) => {
      prevState.forEach((item) => {
        arr.push({
          address: item.address,
          id: item.id,
          lat: item.lat,
          lng: item.lng,
          locationImage: item.image,
          locationName: item.name,
          heroId: me.id
        })
      })
      return [...prevState]
    })

    const saveArr = remove(arr, (item) => {
      return item.id !== locationId
    })

    const saveData = {
      heroId: me.id,
      heroBinLocationList: saveArr
    }

    await saveLocation(saveData)
    await onCloseDelete()
    await fetchData()
  }

  const onOk = async (data) => {
    const arr = []
    setLocationList((prevState) => {
      prevState.forEach((item) => {
        arr.push({
          address: item.address,
          id: item.id,
          lat: item.lat,
          lng: item.lng,
          locationImage: item.image,
          locationName: item.name
        })
      })
      return [...prevState]
    })
    arr.push(data)
    const saveData = {
      heroId: me.id,
      heroBinLocationList: arr
    }
    await saveLocation(saveData)
    await setLocationItem(null)
    await setVisible(false)
    // await onCancel()
    await fetchData()
  }

  const saveLocation = async (data) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/bin/updateLocation`,
        data
      )
      Modal.success({
        content: `${RESPONSE_MESSAGE.SUCCESS}`,
        afterClose() {
          setTimeout(() => {
            document.body.removeAttribute('style')
          }, 0)
        }
      })
    } catch (err) {
      console.log(err)
      message.error(RESPONSE_MESSAGE.FAIL)
    }
  }

  const columns = [
    {
      title: 'ภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.image)
          }}>
          View
        </a>
      )
    },
    {
      title: 'สถานที่',
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      align: 'center'
    },
    {
      title: 'Action',
      align: 'center',
      render: (text, record) => {
        return (
          <Space>
            <a onClick={() => onEdit(record)}>แก้ไข</a>
            <a onClick={() => onClickDelete(record.id)}>ลบ</a>
          </Space>
        )
      }
    }
  ]

  const onClickDelete = (id) => {
    setLocationId(id)
    setVisibleDelete(true)
  }

  const onCloseDelete = () => {
    setVisibleDelete(false)
    setLocationId(null)
  }

  const onOkDelete = async () => {
    await onDelete()
    await setVisibleDelete(false)
    await setLocationId(null)
  }

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }

  const onDeleteAll = async () => {
    const arr = []

    if (selectedRowKeys.length !== locationList.length) {
      setLocationList((prevState) => {
        selectedRowKeys.forEach((rowItem) => {
          prevState.forEach((item) => {
            if (rowItem !== item.id) {
              arr.push({
                address: item.address,
                id: item.id,
                lat: item.lat,
                lng: item.lng,
                locationImage: item.image,
                locationName: item.name
              })
            }
          })
        })
        return [...prevState]
      })
    }

    const data = {
      heroId: me.id,
      heroBinLocationList: arr
    }
    await saveLocation(data)
    await setSelectedRowKeys([])
    await fetchData()
  }

  return (
    <React.Fragment>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            สถานที่ของฉัน
          </Typography>
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      <Title name="สถานที่ของฉัน" />
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContentEx>
          <TabsEx
            type="card"
            tabBarExtraContent={{
              left: null,
              right:
                selectedRowKeys.length !== 0 ? (
                  <Popconfirm
                    title="ต้องการลบรายการที่เลือก ?"
                    onConfirm={onDeleteAll}>
                    <Button
                      type="danger"
                      shape="round"
                      icon={<DeleteOutlined />}>
                      ลบรายการที่เลือก
                    </Button>
                  </Popconfirm>
                ) : null
            }}>
            <TabPane tab="รายการสถานที่" key="1">
              {!isEmpty(locationList) ? (
                <div>
                  <TableEx
                    loading={loading}
                    bordered
                    rowKey={(record) => {
                      return record.id
                    }}
                    dataSource={locationList}
                    columns={columns}
                    rowSelection={rowSelection}
                    title={() => (
                      <Row justify="end">
                        <span
                          style={{
                            color: '#6ebf4b'
                          }}>{`สถานที่ ${locationList.length}/${me.maxLocation}`}</span>
                      </Row>
                    )}
                    footer={() => (
                      <Space>
                        <span style={{ marginLeft: 8 }}>
                          {`เลือก ${selectedRowKeys.length} สถานที่`}
                        </span>
                      </Space>
                    )}
                  />
                </div>
              ) : (
                <Row justify="center">
                  <Space direction="vertical">
                    <Row justify="center">
                      <Avatar size={72} src={LogoNoMaterial} />
                    </Row>
                    <Text size={20}>คุณยังไม่มีวัสดุรีไซเคิลที่รับซื้อ</Text>
                  </Space>
                </Row>
              )}
            </TabPane>
            {/* <TabPane tab="มุมมองแผนที่" key="2"></TabPane> */}
          </TabsEx>
        </CardContentEx>
      </Card>
      <Row justify="center" style={{ marginTop: 15 }}>
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => goBack()}>
            กลับ
          </ButtonEx>
          {locationList.length < me.maxLocation && (
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              เพิ่มสถานที่
            </ButtonEx>
          )}
        </Space>
      </Row>
      <LocationBin
        heroId={me.id}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        locationItem={locationItem}
      />
      <LocationDelete
        visible={visibleDelete}
        onOk={onOkDelete}
        onCancel={onCloseDelete}
      />
    </React.Fragment>
  )
}

AccountLocationBin.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(withRouter, withContext)(AccountLocationBin)



// WEBPACK FOOTER //
// ./src/pages/AccountLocationBin/index.js